import { render, staticRenderFns } from "./NeidaiDataLight.vue?vue&type=template&id=0d722e5c&scoped=true"
import script from "./NeidaiDataLight.vue?vue&type=script&lang=js"
export * from "./NeidaiDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d722e5c",
  null
  
)

export default component.exports